// extracted by mini-css-extract-plugin
export var container = "Icon-module--container--91aQ0";
export var inFlow = "Icon-module--inFlow--PTeyf";
export var notClickable = "Icon-module--notClickable--XhJeo";